/**
 * Piletilevi Sales terminal services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Possible values service, extra, hidden. Where hidden is a subtype of extra and it should not be displayed separately from the ticket price, it should be summed with the ticket price. Upper-cased values for self-service cart.
 */
export type SurchargeType = 'service' | 'extra' | 'hidden' | 'delivery';

export const SurchargeType = {
    Service: 'service' as SurchargeType,
    Extra: 'extra' as SurchargeType,
    Hidden: 'hidden' as SurchargeType,
    Delivery: 'delivery' as SurchargeType
};

